// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__27AC2","list":"BalanceDue_list__1wx7N","listRow":"BalanceDue_listRow__2t12x","total":"BalanceDue_total__1t4Rg"};